import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
// Types
import { GetStoreBySlug_store } from 'api/store/types/GetStoreBySlug';
import { GetStream_stream_store } from 'api/streams/types/GetStream';
import {
  GetMediaPost_getMediaPost_ImagePost_store,
  GetMediaPost_getMediaPost_VideoPost_store,
} from 'api/mediaPost/types/GetMediaPost';
// Ui3
import Modal from 'ui3/Modal/Modal';
import Text from 'ui3/Text/Text';
// Animations
import confettiAnimation from 'public/confetti.json';
// Components
import TipPosterSection from 'components/TipPoster/TipPosterSection';
// Styles
import styles from './TipSuccessModal.module.scss';

interface TipSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  tipData: {
    amount: number;
    message?: string;
    storeName: string;
    store:
      | GetStoreBySlug_store
      | GetStream_stream_store
      | GetMediaPost_getMediaPost_ImagePost_store
      | GetMediaPost_getMediaPost_VideoPost_store;
    id?: string;
  } | null;
  store:
    | GetStoreBySlug_store
    | GetStream_stream_store
    | GetMediaPost_getMediaPost_ImagePost_store
    | GetMediaPost_getMediaPost_VideoPost_store;
  size?: 'small' | 'medium' | 'large';
}

const TipSuccessModal: React.FC<TipSuccessModalProps> = ({
  isOpen,
  onClose,
  tipData,
  store,
  size = 'large',
}) => {
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowConfetti(true);
    } else {
      setShowConfetti(false);
    }
  }, [isOpen]);

  if (!tipData) return null;

  const storeName = store?.storeDetails?.storeName || 'this creator';
  const handleConfettiComplete = () => setShowConfetti(false);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size={size}
      fullPageOnMobile
      className={styles.tipSuccessModal}
      containerClassName={styles.tipSuccessModalContainer}
    >
      <div className={styles.modalContent}>
        {/* Confetti Video */}
        {showConfetti && (
          <Lottie
            animationData={confettiAnimation}
            className={styles.confettiVideo}
            loop={false}
            autoplay={true}
            onComplete={handleConfettiComplete}
          />
        )}

        <div className={styles.successHeader}>
          <Text variant="h3" className={styles.successTitle}>
            Tip Sent Successfully!
          </Text>
          <Text color="lights-low" className={styles.successSubtitle}>
            {`${storeName} appreciates you! Show everyone you're a top supporter!`}
          </Text>
          {tipData.id && <TipPosterSection tipId={tipData.id} />}
        </div>
      </div>
    </Modal>
  );
};

export default TipSuccessModal;
